export default __webpack_public_path__ + "static/media/close.7006f016.svg";